import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { AgentCategoryListDto } from '../../agent-categories/dtos/agent-category-list.dto';
import { TenantContactDto } from '../../contacts/dtos/tenant-contact.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { AgentStatusEnum } from '../enums/agent-status.enum';
import { AgentTypeEnum } from '../enums/agent-type.enum';

/**
 * Agent DTO for lists
 */
@CaslSubject(AppSubjectEnum.AGENT)
export class AgentListDto extends BaseDto {
  uuid!: string;
  code!: string;
  status!: AgentStatusEnum;
  type!: AgentTypeEnum;
  contact!: TenantContactDto;
  agentCategory?: AgentCategoryListDto | null;
  tags?: TagListDto[] | null;
}
